import AnchorLink from 'react-anchor-link-smooth-scroll'
import Img from 'gatsby-image'
import Link from 'gatsby-link'
import React from 'react'

class AboutUsComponent extends React.Component {
  render() {
    return (
      <div className="about-us-wrapper">
        <div className="container">
          <div className="row">
            <div className="box">
              <div className="col-md-12">
                <div className="section-heading text-center">
                  <h2 className="">Über Softwarepiloten</h2>
                  <div className="section-content">
                    <h3>
                      Softwarepiloten sind Henning Zacher (<i>JavaScript Full-Stack Entwickler</i>)
                      <br/>mit seinem Netzwerk von Freelance-Entwicklern, Textern und Designern.
                    </h3>
                    <div className="row about-us-wrapper-row">
                      <div className="col-md-4 about-us-wrapper-profile">
                        <p className="profile-name">Henning Zacher</p>
                        <p className="profile-position">Full-Stack Entwickler, Geschäftsführer Softwarepiloten</p>
                        <Img sizes={this.props.imageStore.profilbildHzImage.sizes} alt="Henning Zacher"/>
                      </div>
                      <div className="col-md-4 about-us-wrapper-strength">
                        <p className="strength-header">Vorstellung</p>
                        <p>
                          Henning Zacher ist ein erfahrener Full-Stack Software-Entwickler, setzt auf Code-Qualität durch Test-Driven-Development und ist auf das Meteor-Framework spezialisiert.
                        </p>
                        <p className="strength-header2">Skillset</p>
                        <ul className="bullet-list">
                          <li>Konzeption (Screendesign, Wireframing, Modellierung von Geschäftsprozessen, Lean-Startup Philosophie)</li>
                          <li>Full-Stack Entwicklung von Web- und Mobile-Apps (Meteor.js, Node.js, React, Blaze, Gatsby, MongoDB)</li>
                          <li>Testing (Test-Driven-Development, Mocha, Chai, Chimp, Continuous Integration)</li>
                          <li>Deployment (Galaxy, MeteorUp, Heroku)</li>
                          <li>Growth Analytics (Segment.io, Mixpanel, ActiveCampaign)</li>
                          <li><i>Background in Django, Php, Wordpress und Java</i></li>
                          <li><i>Sprachen: Deutsch (Muttersprache), Englisch (verhandlungssicher)</i></li>
                        </ul>
                        <p>
                          Details finden Sie unter <Link to="/unsere-staerken">unsere Stärken</Link>.
                        </p>
                        <p>
                          <b>Benötigen Sie Unterstützung für Ihr Projekt?</b> Wir beraten Sie gerne unverbindlich und freuen uns über Ihre Anfrage. Schreiben Sie uns einfach eine <AnchorLink href="#contact">Nachricht über das Kontaktformular</AnchorLink>.
                        </p>
                        <AnchorLink className="btn btn-primary" href="#contact">Jetzt kontaktieren und beraten lassen</AnchorLink>
                      </div>
                      <div className="col-md-4 about-us-wrapper-reference">
                        <p className="reference-header">Referenzen</p>
                        <p className="profile-position">
                          Aktuelles Referenz-Projekt: www.teampilot.de
                        </p>
                        <div>
                          Aufgaben:
                          <ul className="bullet-list">
                            <li>Beratung & Konzeption (Screendesign, Wireframing)</li>
                            <li>Full-Stack Entwicklung (Meteor.js basiert)</li>
                            <li>Testing (Implementierung einer „Continuous Integration“-Umgebung inkl. Unit-, Integrational- und Acceptance-Tests)</li>
                            <li>Marketing Analytics</li>
                          </ul>
                        </div>
                        <a href="https://www.teampilot.de" target="_new">
                          <Img sizes={this.props.imageStore.teamPilotImage.sizes} alt="TeamPilot"/>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AboutUsComponent



// WEBPACK FOOTER //
// ./src/components/AboutUsComponent/index.js